import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const ZakaznikUpravit = lazy(() =>
  import('@/modules/zakaznici/ZakaznikUpravit').then((m) => ({ default: m.ZakaznikUpravit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici/$id/upravit',
  component: () => (
    <Suspense fallback={null}>
      <ZakaznikUpravit />
    </Suspense>
  ),
});
